/**
 * @generated SignedSource<<9b575d6949e91d129e96a373c969f43d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailItemInvoice_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDetailItemInvoice_item";
};
export type PdpSharedDetailItemInvoice_item$key = {
  readonly " $data"?: PdpSharedDetailItemInvoice_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailItemInvoice_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailItemInvoice_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "70aba8784376d80475654a82ae87f2d8";

export default node;
